/**
 * Estimate fuel consumption and CO₂ emissions for PEI's diesel generation.
 *
 * Assumptions:
 * - Average fuel consumption: 280 L per MWh
 * - Emission factor: 2.68 kg CO₂ per liter of diesel
 * - Output is instantaneous hourly-equivalent values based on MW input
 */

export interface EmissionStats {
  mw: number;
  litersPerHour: number;
  co2KgPerHour: number;
  co2TonnesPerHour: number;
}

export function estimateDieselEmissions(mw: number): EmissionStats {
  const FUEL_L_PER_MWH = 280;          // liters per MWh (average diesel generator)
  const CO2_KG_PER_LITER = 2.68;       // kg CO₂ per liter of diesel

  const litersPerHour = mw * FUEL_L_PER_MWH;
  const co2KgPerHour = litersPerHour * CO2_KG_PER_LITER;
  const co2TonnesPerHour = co2KgPerHour / 1000;

  return {
    mw,
    litersPerHour,
    co2KgPerHour,
    co2TonnesPerHour,
  };
}
